import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { inr } from "@/lib/format";

const when = at => {
  if (!at) return "—";
  if (at.length === 10) return at;
  const d = new Date(at);
  return Number.isNaN(d.getTime()) ? at : d.toLocaleString([], { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
};

/** The rows behind one dashboard number: when, table, what, amount, who, why. */
export default function DrillDialog({ title, load, onClose }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let live = true;
    setRows(null);
    setError(null);
    load()
      .then(data => { if (live) setRows(Array.isArray(data) ? data : []); })
      .catch(err => { if (live) setError(err?.response?.data?.detail || err?.message || "Could not load the list"); });
    return () => { live = false; };
  }, [load]);

  return (
    <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
      <DialogContent className="max-w-3xl" data-testid="dash-drill">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {error && <p className="text-meta text-destructive">List not loaded — {String(error)}</p>}
        {!error && rows === null && <p className="text-meta text-muted-foreground">Loading…</p>}
        {rows && rows.length === 0 && <p className="text-meta text-muted-foreground">Nothing in this period.</p>}
        {rows && rows.length > 0 && (
          <>
          {/* Phones: one entry per row, nothing cut off at the right (owner, 2026-10-25). */}
          <ul className="md:hidden max-h-[65vh] overflow-y-auto divide-y" data-testid="dash-drill-list">
            {rows.map((r, i) => (
              <li key={i} className="py-snug">
                <div className="flex items-baseline justify-between gap-snug">
                  <span className="text-body font-medium min-w-0">{r.items || "—"}</span>
                  <span className="text-body font-semibold tabular-nums whitespace-nowrap">{inr(r.amount)}</span>
                </div>
                <div className="mt-hair text-meta text-muted-foreground">
                  {when(r.at)}{r.table ? `, table ${r.table}` : ""}{r.by ? `, by ${r.by}` : ""}
                </div>
                {r.reason && <div className="mt-hair text-meta">{r.reason}</div>}
              </li>
            ))}
          </ul>
          <div className="hidden md:block max-h-[60vh] overflow-auto">
            <table className="w-full text-meta">
              <thead className="text-muted-foreground text-left">
                <tr><th className="py-1 pr-2">When</th><th className="pr-2">Table</th><th className="pr-2">What</th>
                  <th className="pr-2 text-right">Amount</th><th className="pr-2">By</th><th>Reason</th></tr>
              </thead>
              <tbody>
                {rows.map((r, i) => (
                  <tr key={i} className="border-t">
                    <td className="py-1 pr-2 whitespace-nowrap">{when(r.at)}</td>
                    <td className="pr-2">{r.table || "—"}</td>
                    <td className="pr-2">{r.items || "—"}</td>
                    <td className="pr-2 text-right tabular-nums">{inr(r.amount)}</td>
                    <td className="pr-2">{r.by || "—"}</td>
                    <td>{r.reason || "—"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}
